import { useEffect, useState } from 'react';
import References from '../../helpers/Reference';
import AuthService from './auth.modules.js';
import { useAuth } from './store';
import { jwtDecode } from 'jwt-decode';

import { LoadingOutlined, UserOutlined, UnlockOutlined, LoginOutlined, LogoutOutlined } from '@ant-design/icons';
import { Input, Button, Modal, Alert } from 'antd';

import IcoProfile from '../../images/ico_profile.svg';
import IcoEnter from '../../images/ico_enter.svg';

import { Button as CustomButtom } from '../Buttons/button';
import { fromRefByDomain } from '../../helpers/helpers.js';
import { useSubdomains } from '../Subdomains/store.js';
import { clearStationFilters } from '../../helpers/helpers.js';

export const Auth = () => {

    const [ login, setLogin ] = useState('');    
    const [ password, setPassword] = useState('');

    const { isAuth, permission, authError, isAuthorized, isExpired } = useAuth();
    const {subdomainSettings, isPresetExist} = useSubdomains()

    const [ isShowAuthWindow, setIsShowAuthWindow ] = useState( !isAuth );        
    
    useEffect(() => {
        if (!isAuth ) {
            setIsShowAuthWindow( true );
        }
    }, 
    [isAuth]);

    const onLoginButtonClick = ( l, p ) => {
            useAuth.setState({isAuthorized: true});
            AuthService.login( l, p )
            .then(data => {
                AuthService.afterLogon(data, setIsShowAuthWindow, setIsShowAuthWindow, false, true)
            })
    }

    const onAnonimusLoginButtonClick = () => {
        let l = fromRefByDomain(['default_user', 'user'], subdomainSettings);
        let p = fromRefByDomain(['default_user', 'password'], subdomainSettings);//References.anonimus.password;            
        onLoginButtonClick(l, p);           
        clearStationFilters();                     
    }

    const onLogoutButtonClick = () => {
    	AuthService.logout();
        useAuth.setState({isAuth: false});
        setIsShowAuthWindow( true );        
        clearStationFilters();
    }

    const onLogoutAllButtonClick = () => {
    	AuthService.logoutAll();
        useAuth.setState({isAuth: false});
        setIsShowAuthWindow( true );                
    }

    const onShowAuthWindow = () => {
        setIsShowAuthWindow( true );
    }

    const onHideAuthWindow = () => {
        setIsShowAuthWindow( false );
    }

    if (subdomainSettings?.default_user?.default_user_only)
        return
            <></>;

    return (
        <>
            <Modal 
                title="Авторизация" 
                open={isShowAuthWindow} 
                onCancel={onHideAuthWindow}
                footer={[]}
            >
            <div className="mt-2 p-2">
            {(isAuth && !permission.is_anonymous) ? (
                <div className="text-center">
                    <Button id="logout-button" onClick={onLogoutButtonClick} icon={<LogoutOutlined />}>Выйти</Button>
                    <Button id="logoutall-button" onClick={onLogoutAllButtonClick} icon={<LogoutOutlined />} className="ml-1">Выйти на всех устройствах</Button>
                </div>
            ) : (
                <div>      
                    {authError &&
                            <Alert
                            description={References.dictionary[authError]}
                            type="error"
                            showIcon
                          />
                    }
                    {!subdomainSettings?.default_user?.default_user_only &&
                    <div>
                    <div className="mt-1">
                        <Input 
                            type="text"
                            onChange={e => setLogin(e.target.value)}
                            placeholder="Логин"
                            prefix={<UserOutlined />}
                         />
                    </div>
                    <div className="mt-1">
                        <Input 
                            type="password"
                            onChange={e => setPassword(e.target.value)}
                            placeholder="Пароль"
                            prefix={<UnlockOutlined />}
                         />
                    </div>
                    </div>
                    }
                    <div className="text-center mt-1">
                        {isAuthorized &&
                            <LoadingOutlined className="mr-2"/>
                        }
                        {!subdomainSettings?.default_user?.default_user_only &&
                        <Button id="login-button" onClick={() => onLoginButtonClick(login, password)} icon={<LoginOutlined />}>Войти</Button>
                        }
                        {(References.hasOwnProperty('default_user') && (subdomainSettings?.default_user?.user?.length > 0 || !isPresetExist)) &&
                            <Button id="anonimus-login-button" onClick={onAnonimusLoginButtonClick} icon={<LoginOutlined />} className="ml-2">Продолжить без авторизации</Button>                        
                        }

                    </div>                    
                </div>

            )}                          
            </div>
            </Modal>

            {!subdomainSettings?.default_user?.default_user_only &&
            <CustomButtom 
                id="auth_btn"
                type="circle"
                position={{right: 10, top: 10}}
                icon={isAuth ? IcoProfile : IcoEnter}
                tooltip={{
                    title: isAuth ? References.dictionary.tooltips.button_logout : References.dictionary.tooltips.button_login,
                    placement: "right"
                }}
                size="md"
                handleClick={onShowAuthWindow}
            />
            }

            
        </>
	)

}